/* hc-colsl.js — fleches du slider de collections (« Nos hachoirs »), 20-08-2026. Charge en defer.
   Le defilement fonctionne sans JS (scroll tactile) : ce script n'ajoute que les fleches desktop. */
var HC_SLIDERS = window.HC_SLIDERS || [
  { section: '.hc-cs',  piste: '.hc-cs__track', item: '.hc-cs__item',  prev: '.hc-cs__arrow--prev',  next: '.hc-cs__arrow--next',  gap: 18 },
  { section: '.hc-sel', piste: '.hc-sel__grid', item: '.hc-sel__card', prev: '.hc-sel__arrow--prev', next: '.hc-sel__arrow--next', gap: 18 }
];
window.HC_SLIDERS = HC_SLIDERS;

document.addEventListener('DOMContentLoaded', function () {
  // Ce fichier est reference par DEUX sections (collections et produits) : deux balises <script>
  // avec la meme URL s'executent bel et bien toutes les deux. Sans ce verrou, chaque fleche
  // recevrait deux ecouteurs et un clic ferait defiler deux fois (constate le 21/08).
  if (window.__hcSlidersInit) return;
  window.__hcSlidersInit = true;

  HC_SLIDERS.forEach(function (cfg) {
  document.querySelectorAll(cfg.section).forEach(function (section) {
    var track = section.querySelector(cfg.piste);
    var prev = section.querySelector(cfg.prev);
    var next = section.querySelector(cfg.next);
    if (!track || !prev || !next) return;

    function pas() {
      var item = track.querySelector(cfg.item);
      if (!item) return 280;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || cfg.gap;
      var largeur = item.getBoundingClientRect().width + gap;
      // on avance d'autant de cartes entieres que la fenetre peut en montrer
      var visibles = Math.max(1, Math.floor(track.clientWidth / largeur));
      return largeur * visibles;
    }

    // On grise les fleches avec une classe et non l'attribut « disabled » :
    // un etat fige (onglet en arriere-plan, evenement scroll non emis) ne doit jamais
    // empecher le clic. La classe est purement visuelle.
    function majEtat() {
      var max = track.scrollWidth - track.clientWidth;
      var auDebut = track.scrollLeft <= 2;
      var aLaFin = track.scrollLeft >= max - 2;
      prev.classList.toggle('is-off', auDebut);
      next.classList.toggle('is-off', aLaFin);
      prev.setAttribute('aria-disabled', auDebut ? 'true' : 'false');
      next.setAttribute('aria-disabled', aLaFin ? 'true' : 'false');
    }

    function deplacer(sens) {
      track.scrollBy({ left: sens * pas(), behavior: 'smooth' });
      // l'evenement scroll peut ne pas arriver : on rafraichit aussi apres coup
      setTimeout(majEtat, 450);
      setTimeout(majEtat, 900);
    }

    prev.addEventListener('click', function () { deplacer(-1); });
    next.addEventListener('click', function () { deplacer(1); });

    track.addEventListener('scroll', majEtat, { passive: true });
    window.addEventListener('resize', majEtat, { passive: true });
    majEtat();
  });
  });
});
